// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hc-0";